/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	var Viewport = {};

	Viewport.documentWidth = function(){
		var e = window, a = 'inner';
		if (!('innerWidth' in window )) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

  var Nav = {};

  Nav.checkHeight = function() {
    var $navbar = $( '.navbar' );
    var navHeight = $navbar.height();
    //var navNewHeight = $( '.navbar-header' ).height() + $( '.navbar-collapse' ).height();
    var windowHeight = $( window ).height();

    if( Viewport.documentWidth().height < navHeight + 20 ) {
    	$navbar.removeClass('affix');
    } else {
		$navbar.addClass('affix');
	}
  };

  Nav.mobileStick = function() {
    var scrollPos = 0;

    $('.navbar-collapse').on('show.bs.collapse', function() {
      $('.navbar-toggle').addClass('open').delay(200).queue(function() {
        $('.icon-bar').addClass('closing').dequeue();
      });
      scrollPos = $( window ).scrollTop();

    }).on('hide.bs.collapse', function() {
      $('.icon-bar').removeClass('closing').delay(200).queue(function() {
        $('.navbar-toggle').removeClass('open').dequeue();
      });
      $( 'html, body' ).removeClass( 'lock-position' );
      $( window ).scrollTop( scrollPos );

    }).on( 'shown.bs.collapse', function() {
      $( 'html, body' ).addClass( 'lock-position' );
    } );
  };

	var Footer = {};

	Footer.switcher = function() {
		if( Viewport.documentWidth().width <= 767 ) {

			var title = $( '.footer-social-icons .hidden-xs .title' );
			$( '.fsi-group .title span' ).text( title.html() + ' ' );

		}
		else {
			$( '.fsi-group .title span' ).text( '' );
		}
	};

	Footer.scrollTop = function() {
		$( ".scrolltop" ).click(function() {
			$('html, body').animate({
				scrollTop: 0
			}, 800);
		});
	};

	var Product = {};

	Product.Filter = function () {
		$('[data-toggle="toggle"]').click(function(e) {

			if ( $(window).width() < 768 ) {

				if ( $(e.target).parent().hasClass('active') ) {
					e.preventDefault();
				}
				if ( !$('.category-filter').hasClass('open') ) {
					$('.category-filter').children().slice(1).slideDown('slow');

				} else {
					$('.category-filter').children().not('.active').slideUp('slow');

				}

				$('.category-filter').toggleClass('open');
			}
		});

		$(window).resize(function() {
			if ($(this).width() > 767 ) {
				$('.category-filter').children().css({display: 'inline-block'});
			} else {
				$('.category-filter').children().not('.active').hide();
			}
		});
	};


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
		$('i.dropdown-toggle').on('click', function() {
			$(this).parents('li').toggleClass('open');
		});

  		  $( ".tooltip-active" ).tooltip({'trigger':'focus', 'title': 'Password tooltip'});

    		$(".qa .question").click(function() {
    			if ( $( this ).parents( '.qa' ).hasClass( "in" ) ) {
    				$( this ).parents( '.qa' ).removeClass( 'in' );
    				$( this ).parents( '.qa' ).children( '.answer' ).slideDown();
    				$( this ).parents( '.qa' ).addClass( 'out' );

    			} else {
    				// $( this ).parents( '.qa' ).children( '.answer' ).slideUp();
    				$( this ).parents( '.qa' ).children( '.answer' ).slideUp(400, function() {
    					$( this ).parents( '.qa' ).addClass( 'in' );
    					$( this ).parents( '.qa' ).removeClass( 'out' );
    				});
    			}
    		});

        /* Functions */
        Nav.checkHeight();
        Nav.mobileStick();
    	Footer.switcher();
    	Footer.scrollTop();
		//Loader.init();

		$( document ).ready( function() {
			if ( $('#signup-newsletter').data('firstvisit') === true ) {
				$( '#signup-newsletter' ).modal( 'show' );
			}
		} );

		$( window ).on( 'resize', function() {
			Nav.checkHeight();
			Footer.switcher();
		} );

		$('#signup-newsletter').on('hide.bs.modal', function (e) {
			$.post($('.newsletter-close').data('ajaxurl'), {action: 'mollers_newsletter'});
		});

		$('#read-more').on('click', function() {
			$('.post, .article-wrap').removeClass('less-content');
			$(this).parent().hide();
		});

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'single': {
        init: function() {

        }
    },
	// 'category': {
	// 	init: function() {
	// 		$('head').append('<style type="text/css">.page-header:before{min-height: ' + ($('.page-header').height() + 150) + 'px !important;}</style>');
	// 	}

	// },
	'search' : {
		init: function () {
			$('.input-container .search-icon').on('click', function () {
				$(this).parents('form').submit();
			});
		}
	},
	'page_template_template_product': {
		init: function() {
			Product.Filter();
		}
	},
	'tax_product_categories' : {
		init: function() {
			Product.Filter();
		}
	},
	'page_template_template_history' : {
		init: function() {
			if ( $('.more-timeline').length ) {
				$('.more-timeline').on('click', function(e) {
					e.preventDefault();
					$(this).prev().find('.les').toggle('slow');
				});
			}
		}
	},
	'page_template_template_faq' : {
		init: function() {
			//$(".qa .question").click();
			if ( window.location.hash ) {
				$(window.location.hash + ' .question').click();
			}
		}
	}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    headerSearchButton : function() {
        $('.header-search > .search-form .search-field').on('focus', function () {
            $(this).parent().addClass('open');
        });

        $('.header-search').mouseleave(function () {
            $('.header-search > .search-form .search-field').parent().removeClass('open');
        });

    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        UTIL.headerSearchButton();
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


})(jQuery); // Fully reference jQuery after this point.

// Sharer function
function Sharer(type, url, title, descr, image, winWidth, winHeight) {
	if ( type === 'fb' ) {
		sharer = 'http://www.facebook.com/sharer.php?u=' + url;
	} else {
		//sharer = 'https://twitter.com/intent/tweet?text=' + url;
		sharer = 'https://twitter.com/intent/tweet?text=' + title + '&url=' + url;
	}
	var winTop = (screen.height / 2) - (winHeight / 2);
	var winLeft = (screen.width / 2) - (winWidth / 2);
	window.open(sharer, 'Sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}

// Newletter function to pass to Contactform7
function Newsletter() {
	var j = jQuery.noConflict();

	if ( j( '#signup-newsletter' ).is(':visible') ) {
		j( '.modal-dialog-newsletter' ).fadeOut();
		j( '.modal-dialog-notif' ).fadeIn();
	} else {
		j( '#signup-newsletter' ).on('show.bs.modal', function() {
			j( '.modal-dialog-newsletter' ).hide();
			j( '.modal-dialog-notif' ).show();
		});
		j( '#signup-newsletter' ).modal( 'show' );
	}
}
